@if (props?.type === 'number') {
    <!-- cannot set readonly, or disabled (is set from formControl) -->
    <app-phx-input-number
        pInputNumber
        class="w-full"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [useGrouping]="props?.useGrouping"
        [autofocus]="props?.autofocus"
        [placeholder]="props?.placeholder"
        [required]="props?.required"
        [dataTestId]="props?.attributes?.['data-testid']"
        [minFractionDigits]="minFractionDigits()"
        [maxFractionDigits]="maxFractionDigits()"
        [minValue]="props?.minValue"
        [maxValue]="props?.maxValue"
        [upDownButtons]="props?.upDownButtons"
        [buttonLayout]="props?.buttonLayout"
        [currency]="props?.currency"
        [readonly]="props?.readonly"
    />
} @else if (props?.type === 'password') {
    <app-phx-input-password
        ngDefaultControl
        class="w-full"
        [formControl]="formControl"
        [props]="props"
        [dataTestId]="props?.attributes?.['data-testid']"
    />
} @else if (props?.type === 'autocomplete') {
    <app-phx-input-auto-complete
        class="w-full"
        [control]="formControl"
        [props]="props"
        [testid]="props?.attributes?.['data-testid']"
        [mode]="props?.mode"
    />
} @else if (props?.type === 'clipboard') {
    <app-phx-input-clipboard
        ngDefaultControl
        class="w-full"
        [formControl]="formControl"
        [props]="props"
        [dataTestId]="props?.attributes?.['data-testid']"
    />
} @else {
    <input
        pInputText
        class="w-full"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [autofocus]="props?.autofocus"
        [type]="props?.type"
        [placeholder]="props?.placeholder"
        [readonly]="props?.readonly"
        [required]="props?.required"
        [type]="props?.type || 'text'"
        [attr.data-testid]="props?.attributes?.['data-testid']"
        phx-mention
    />
}
